import React, { useState, useContext, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  Grid,
  Typography,
  Button,
  createTheme,
  ThemeProvider,
  TextField,
  Tooltip,
  Fab,
  CircularProgress,
} from "@material-ui/core";
import {
  ApptContext,
  Facility,
  InitialApptObj,
  Provider,
} from "../../../../../../store";
import useStyles from "../../../../../../css/styles_PE";
import {
  GetAvailableSlotsByDate,
  GetFacilityProviders,
  GetLocationsByDate,
  GetProviderSlotsByDate,
} from "../../../../../../api/PE_API";
import { format } from "date-fns";
import { Autocomplete } from "@mui/lab";
import { Replay } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { InsertPPLogs } from "../../../../../../api";

// Update log
// FB  6192   02/06/2023  DK  Added for by date workflow
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  7882   12/26/2023  SK  Book Appointment Flow isn't working in EDGE and SAFARI browser, Desktop and Smartphones - Patient Portal
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8796   06/23/2024  KI  Auto selecting location and provider if we have only one data
// FB  9379   09/04/2024  KI  Appointment is not showing when default facility is selected in portal
// FB  8722   11/06/2024  DK  PE workflows enhancements


export default function DateComponent(props: any) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });
  const { state, dispatch } = useContext(ApptContext);
  const navigate = useNavigate();
  const styles = useStyles();
  const [providers, setProviders] = useState<Provider[]>([]);
  const [providersopen, setProvidersOpen] = useState(false);
  const providersLoader = providersopen && providers.length === 0;
  const [selectedprovider, SetSelectedProvider] = useState<Provider>(
    InitialApptObj.Provider
  );
  const [facilities, setFacilities] = useState<Facility[]>([]);
  const [facilitiesopen, setFacilitiesOpen] = useState(false);
  const facilitiesLoader = facilitiesopen && facilities.length === 0;
  const [selectedfacility, SetSelectedfacility] = useState<Facility>(
    state.Facility
  );
  const [selectedDate, setSelectedDate] = useState(state.AppointmentDate);
  const [availableSlots, setAvailableSlots] = useState<number>();
  const [isDisabled, setIsDisabled] = useState(false);
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  const resetForm = () => {
    SetSelectedProvider(InitialApptObj.Provider);
    SetSelectedfacility(InitialApptObj.Facility);
    setSelectedDate(new Date());
    state.AppointmentDate = new Date();
    GetLocationsByDate(format(selectedDate, "MM-dd-yyyy"), 0).then((data) => {
      setFacilities(data);
    });
    InsertPPLogs("Click on Reset", window.location.href, userName, "");
  };

  const handleProviderChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedProvider(value as Provider);
      InsertPPLogs(
        "Choosed the provider " + value.name,
        window.location.href,
        userName,
        ""
      );
      state.Provider = value as Provider;
      //ModifyAppointmentObject(state,dispatch);
    } else {
      SetSelectedProvider(InitialApptObj.Provider);
    }
  };

  const handleLocationChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedfacility(value as Facility);
      InsertPPLogs(
        "Choosed the location " + value.name,
        window.location.href,
        userName,
        ""
      );
      state.Provider = {
        ID: 0,
        Name: "",
        Facility_n: 0,
        Bio: "",
        JobTitle: ""
      };
      state.Facility = value as Facility;
      //ModifyAppointmentObject(state,dispatch);
    } else {
      SetSelectedfacility(state.Facility);
    }
  };

  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      InsertPPLogs(
        "Changed the date to " + date.toDateString(),
        window.location.href,
        userName,
        ""
      );
      state.Facility = {
        ID: 0,
        Name: "",
        Address: "",
        Phone: "",
        Region: 0,
        GOOGLE_MAPS_LINK:"" //FB 7413

      };
      state.FacilityRegion = {
        ID: 0,
        Name: "",
        State: ""
      };
      state.Provider = {
        ID: 0,
        Name: "",
        Facility_n: 0,
        Bio: "",
        JobTitle: ""
      };
      state.AppointmentDate = date;
      //ModifyAppointmentObject(state,dispatch);
    }
  };

  const handleGoback = () => {
    props.setApptFilter("");
    InsertPPLogs(
      "Clicked on go back - by date",
      window.location.href,
      userName,
      ""
    );
  };

  const handleProceed = () => {
    InsertPPLogs(
      "Clicked on Show Schedule - by date",
      window.location.href,
      userName,
      ""
    );
    navigate("/user/bookappointment/date/slots");
  };

  const scrollTo = (ref: any) => {
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    SetSelectedProvider(InitialApptObj.Provider);
    SetSelectedfacility(InitialApptObj.Facility);
    GetLocationsByDate(format(selectedDate, "MM-dd-yyyy"), 0).then((data: any) => { //FB 8796
      setFacilities(data);
	  //FB 8796
      if (data.length == 1) {
        SetSelectedfacility(data[0]);
        state.Facility = data[0] as Facility; //FB 9379
      }
    });
  }, [selectedDate]);

  useEffect(() => {
    let splittedDate = selectedDate.toLocaleDateString().split("/");
    //FB 7882 - Begin
    let value = new Date(selectedDate);
    let formattedSelectedDate = `${(value.getMonth() + 1).toString().padStart(2, '0')}-${value.getDate().toString().padStart(2, '0')}-${value.getFullYear()}`;
    GetProviderSlotsByDate(formattedSelectedDate, 0, 0).then((data) => {
      setAvailableSlots(data.length);
    });
  }, [selectedDate]);
  //FB 7882 - End

  useEffect(() => {
    //FB 8722
    let session_ApptN = sessionStorage.getItem("AppointmentType_N");
    let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;//FB 8024
    if (selectedfacility.ID > 0) {
      SetSelectedProvider(InitialApptObj.Provider);
      GetFacilityProviders(
        format(selectedDate, "MM-dd-yyyy"),
        selectedfacility.ID,
        0,
        appt_type_n
      ).then((data: any) => { //FB 8796
        setProviders(data);
		//FB 8796
      if (data.length == 1) {
        SetSelectedProvider(data[0]); 
        state.Provider = data[0] as Provider; //FB 9379
      }
      });
    }
  }, [selectedfacility]);//FB 8024

  useEffect(() => {
    if (selectedfacility.ID != 0) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [selectedfacility]);

  // useEffect(() => {
  //   state.Provider = InitialApptObj.Provider;
  // }, [selectedDate]);

  return (
    <div ref={scrollTo}>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          direction="row"
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography id="selectDate" variant="h6">
            Please select the date
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="row" spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          direction="row"
          style={{ marginTop: 15 }}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                className={styles.datepickerroot}
                id="selectDateSlotsPage"
                style={{ width: "-webkit-fill-available" }}
                inputVariant="standard"
                orientation={window.innerWidth > 768 ? "landscape" : "portrait"}
                value={selectedDate}
                onChange={(date) => handleDateChange(date)}
                format="MM/dd/yyyy"
                minDate={new Date()}
                minDateMessage="Date should not be in past"
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              disableClearable
              id="facilitylist"
              className={styles.dropdown_nomargin}
              value={selectedfacility}
              onChange={handleLocationChange}
              getOptionLabel={(option) => option.Name}
              options={facilities}
              open={facilitiesopen}
              loading={facilitiesLoader}
              onOpen={() => {
                setFacilitiesOpen(true);
              }}
              onClose={() => {
                setFacilitiesOpen(false);
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              classes={{
                popupIndicator: styles.autocompleteIcon,
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Location*"
                  variant="standard"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {facilitiesLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4} //FB 4769
          style={{ display: selectedfacility.ID > 0 ? "block" : "none" }}
        >
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="providerlist"
              className={styles.dropdown_nomargin}
              value={selectedprovider}
              onChange={handleProviderChange}
              getOptionLabel={(option) =>
                option.JobTitle != "" && option.JobTitle != undefined
                  ? option.Name + " (" + option.JobTitle + ")"
                  : option.Name
              }
              options={providers}
              loading={providersLoader}
              open={providersopen}
              onOpen={() => {
                setProvidersOpen(true);
              }}
              onClose={() => {
                setProvidersOpen(false);
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              classes={{
                popupIndicator: styles.autocompleteIcon,
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider(optional)"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {providersLoader ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
        {window.innerWidth < 768 ? (
          <Grid
            item
            xs={12}
            style={{
              marginTop: -5,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Tooltip title="Reset">
              <Fab
                size="small"
                className={styles.fabButton}
                onClick={resetForm}
              >
                <Replay />
              </Fab>
            </Tooltip>
          </Grid>
        ) : (
          <Grid item md={1} style={{ marginTop: -5 }}>
            <Tooltip title="Reset">
              <Fab
                size="small"
                className={styles.fabButton}
                onClick={resetForm}
              >
                <Replay />
              </Fab>
            </Tooltip>
          </Grid>
        )}
      </Grid>

      <Grid
        container
        spacing={3}
        direction="row"
        style={{ display: availableSlots === 0 ? "flex" : "none" }}
      >
        <Grid item xs={12}>
          <Typography variant="h6" style={{ color: "red" }}>
            No appointments available for the selected date. Please select
            another date.
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={3}
        direction="row"
        alignContent="flex-end"
        justify="flex-end"
        style={{ marginTop: 25 }}
      >
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            id="showSchedule"
            className={styles.navigationButton}
            onClick={handleProceed}
            disabled={isDisabled}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            onClick={handleGoback}
            id="goBackDate"
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
